import { URI_TARIFF_PLAN } from '@/config/config';

export default async ({ rootState }, { id }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await fetch(`${URI_TARIFF_PLAN}tariff-plan/${id}`, opts);
  const jsonResult = await response.json();

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors);
  }

  return jsonResult;
};
